module.exports={render:function (){with(this) {
  return _h('div', [((this.currentUser && this.currentUser.type == 'administrator')) ? _h('div', {
    staticClass: "container mainContent"
  }, [_m(0), " ", _m(1), " ", _m(2), " ", _h('transition', {
    attrs: {
      "appear": "",
      "name": "fade",
      "mode": "out-in"
    }
  }, [_h('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_m(3), " ", _h('tbody', [_l((users), function(user) {
    return _h('tr', {
      key: user['.key']
    }, [_h('td', [_s(user.surname) + ", " + _s(user.forename)]), " ", _h('td', [_h('a', {
      attrs: {
        "href": 'mailto:' + user.email
      }
    }, [_s(user.email)])]), " ", _h('td', [_s(user.type)]), " ", _h('td', [_s(_f("epochtoreal")(user.entered))]), " ", _h('td', [_s(_f("epochtoreal")(user.emailopened))]), " ", _h('td', [_s(_f("epochtoreal")(user.inviteaccepted))]), " ", _h('td', {
      staticClass: "text-center"
    }, [(user.ai2016) ? _h('span', ["ai16,"]) : _e(), (user.scientificcommittee) ? _h('span', ["sc,"]) : _e()]), " ", _m(4, true), " ", _m(5, true), " ", _m(6, true)])
  })])])])]) : _h('div', {
    staticClass: "container mainContent"
  }, [_h('h2', ["An error has occured"]), " ", _h('p', ["Sorry, but you're not authorised to view this page."])]), " "])
}},staticRenderFns: [function (){with(this) {
  return _h('h2', ["User Management"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_h('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, ["Add User"])]), " ", _h('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, ["Import Users"])])])
}},function (){with(this) {
  return _h('br')
}},function (){with(this) {
  return _h('thead', [_h('tr', [_h('th', ["Name"]), " ", _h('th', ["Email"]), " ", _h('th', ["User Level"]), " ", _h('th', ["Invite Sent"]), " ", _h('th', ["Opened"]), " ", _h('th', ["Accepted"]), " ", _h('th', {
    staticClass: "text-center"
  }, ["Groups"]), " ", _h('th', {
    staticClass: "text-center"
  }, ["-"]), " ", _h('th', {
    staticClass: "text-center"
  }, ["-"]), " ", _h('th', {
    staticClass: "text-right"
  }, ["Functions"])])])
}},function (){with(this) {
  return _h('td')
}},function (){with(this) {
  return _h('td')
}},function (){with(this) {
  return _h('td', {
    staticClass: "text-right"
  }, [_h('div', {
    staticClass: "btn-group btn-group-xs",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [_h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, ["Edit User"]), " ", _h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, ["Reset Password"]), " ", _h('button', {
    staticClass: "btn btn-default btn-danger",
    attrs: {
      "type": "button"
    }
  }, ["Delete User"])])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-11!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/manageusers.vue
 ** module id = 82
 ** module chunks = 2
 **/